/**
 * Shared config. Secrets MUST come from environment variables — see root `.env.example`.
 * Create React App inlines only `REACT_APP_*` for the browser bundle; Node uses the same names or CALENDLY_API_KEY / JWT names below.
 */

const PORT = process.env.PORT || 8080;
const BASE_URL = process.env.REACT_APP_BASE_URL || "https://repeatconnect.com";
const BASE_URL_API = `${BASE_URL}/api/klantenportaal`;

const CALENDLY_API_KEY =
  process.env.CALENDLY_API_KEY || process.env.REACT_APP_CALENDLY_API_KEY || "";

const CALENDLY_USER_ID =
  process.env.CALENDLY_USER_ID ||
  process.env.REACT_APP_CALENDLY_USER_ID ||
  "b75250d5-32da-42c6-a54c-376aa2abba4a";
const CALENDLY_ORGANIZATION_ID =
  process.env.CALENDLY_ORGANIZATION_ID ||
  process.env.REACT_APP_CALENDLY_ORGANIZATION_ID ||
  "e5ba7299-d262-4435-acc9-67a68893e28f";
const CALENDLY_WEBHOOK_ID =
  process.env.CALENDLY_WEBHOOK_ID || "b4ce34b6-0b3d-4d3b-839b-1bdbc743fd80";
const CALENDLY_SCHEDULED_EVENT_ID =
  process.env.CALENDLY_SCHEDULED_EVENT_ID || "463gpln5sm50hpldof0kqckcic";

const BASE_URL_API_CAL = "https://api.calendly.com";
const BASE_URL_API_CAL_WEBHOOK = `${BASE_URL_API_CAL}/webhook_subscriptions`;
const BASE_URL_API_CAL_SCHEDULED_EVENTS = `${BASE_URL_API_CAL}/scheduled_events`;
const BASE_URL_API_CAL_EVENT_TYPES = `${BASE_URL_API_CAL}/event_types`;
const BASE_URL_API_CAL_USERS = `${BASE_URL_API_CAL}/users`;
const BASE_URL_API_CAL_USERS_ME = `${BASE_URL_API_CAL}/users/me`;
const BASE_URL_API_CAL_INVITEES = `${BASE_URL_API_CAL}/invitees`;
const BASE_URL_API_CAL_INVITATIONS = `${BASE_URL_API_CAL}/invitations`;
const BASE_URL_API_CAL_ORGANIZATIONS = `${BASE_URL_API_CAL}/organizations`;
const BASE_URL_API_CAL_WEBHOOKS = `${BASE_URL_API_CAL}/webhooks`;
const BASE_URL_API_CAL_WEBHOOK_SUBSCRIPTIONS = `${BASE_URL_API_CAL}/webhook_subscriptions`;

const IMAGE_URL_API = process.env.REACT_APP_IMAGE_URL_API || "http://localhost:80";
const DOCUMENTS_URL_API =
  process.env.REACT_APP_DOCUMENTS_URL_API || "http://localhost:8075";
const PAGESIZE = 25;

const ACCESS_TOKEN_SECRET =
  process.env.ACCESS_TOKEN_SECRET ||
  (process.env.NODE_ENV === "production"
    ? ""
    : "development-only-access-secret-change-in-env");
const REFRESH_TOKEN_SECRET =
  process.env.REFRESH_TOKEN_SECRET ||
  (process.env.NODE_ENV === "production"
    ? ""
    : "development-only-refresh-secret-change-in-env");
const TOKEN_EXPIRY = process.env.TOKEN_EXPIRY || "2h";
const REFRESH_TOKEN_EXPIRY = process.env.REFRESH_TOKEN_EXPIRY || "7";

const MAKE_SOCKET_CHANNEL = (id, channel) => {
  if (id == null || id === "") return channel;
  return `${channel}_${String(id)}`;
};

const SOCKET_CHANNELS = {
  COMMENTS: "RP_COMMENTS",
  USERS: "RP_USERS",
  PREINTAKE: "RP_PREINTAKE",
  EETDAGBOEK: "RP_EETDAGBOEK",
  MAIL: "RP_MAIL",
  MAIL_ITEM: "RP_MAIL_ITEM",
  AFSPRAKEN: "RP_AFSPRAKEN",
  VRAGENLIJSTEN: "RP_VRAGENLIJSTEN",
  KLACHTENFORMULIER: "RP_KLACHTENFORMULIER",
  DOCUMENTEN: "RP_DOCUMENTEN",
  VOORUITGANG: "RP_VOORUITGANG",
};

module.exports = {
  SOCKET_CHANNELS,
  MAKE_SOCKET_CHANNEL,
  PORT,
  BASE_URL,
  BASE_URL_API,
  IMAGE_URL_API,
  BASE_URL_API_CAL,
  CALENDLY_API_KEY,
  CALENDLY_USER_ID,
  CALENDLY_ORGANIZATION_ID,
  CALENDLY_WEBHOOK_ID,
  CALENDLY_SCHEDULED_EVENT_ID,
  BASE_URL_API_CAL_WEBHOOKS,
  BASE_URL_API_CAL_WEBHOOK_SUBSCRIPTIONS,
  BASE_URL_API_CAL_SCHEDULED_EVENTS,
  BASE_URL_API_CAL_EVENT_TYPES,
  BASE_URL_API_CAL_USERS,
  BASE_URL_API_CAL_USERS_ME,
  BASE_URL_API_CAL_INVITEES,
  BASE_URL_API_CAL_INVITATIONS,
  BASE_URL_API_CAL_ORGANIZATIONS,
  DOCUMENTS_URL_API,
  PAGESIZE,
  ACCESS_TOKEN_SECRET,
  REFRESH_TOKEN_EXPIRY,
  REFRESH_TOKEN_SECRET,
  TOKEN_EXPIRY,
};
